module.exports = __webpack_public_path__ + "static/media/day-10-measurements.d2fc83f7.svg";